import { Card, Col, DatePicker, Input, Select, Space, Table, TableProps } from "antd";
import { EListingSellOrRent, EListingStatus, ListingProperties } from "../../types/listing.type";
import { Link } from "react-router-dom";
import NotSet from "../../components/NotSet";
import { formatDate, formatUcWords } from "../../helpers/format";
import SellOrRentComponent from "../../components/SellOrRentComponent";
import CustomPagination from "../../components/CustomPagination";
import Filter from "../../components/Filter";
import { SearchOutlined } from "@ant-design/icons";
import FilterOffice from "../../components/form/FilterOffice";
import { PRESET_DATE_RANGES } from "../../helpers/date";
import moment from "moment";

interface IProps {
	data: ListingProperties[];
	setQuery: any;
	query: any;
	search?: string;
	setSearch: any;
	isLoading: boolean;
	pagination?: any;
	changePage?: any;
}
export default function Listing(props: IProps) {
	const { setQuery, query, data, search, setSearch, isLoading, pagination, changePage } = props;

	const _handleFilterOffice = (value: string) => {
		setQuery({
			...query,
			offset: 0,
			filterOfficeId: value,
		});
	};

	const COLUMNS: TableProps<ListingProperties>["columns"] = [
		{
			title: "LISTING ID",
			key: "listingCode",
			dataIndex: "listingCode",
			width: 120,
			render: (listingCode: string, record: ListingProperties) => {
				return (
					<Link to={"/listing/" + record.listingId + "/detail"}>
						{listingCode ? listingCode?.toUpperCase() : <NotSet />}
					</Link>
				);
			},
		},
		{
			title: "TITLE",
			key: "title",
			dataIndex: "title",
			width: 200,
			render: (value: string, record: ListingProperties) => <Space>{value ?? <NotSet />}</Space>,
		},

		{
			title: "OFFICE",
			dataIndex: ["office", "officeName"],
			key: "officeName",
			width: 150,
		},
		{
			title: "AGENT NAME",
			dataIndex: ["user", "nickName"],
			key: "nickName",
			width: 200,
			render: (nickName: string) => <>{nickName ? nickName?.toUpperCase() : <NotSet />}</>,
		},
		{
			title: "POSTING DATE",
			dataIndex: "publishAt",
			key: "publishAt",
			width: 150,
			render: formatDate,
		},
		{
			title: "TYPE",
			dataIndex: "sellOrRent",
			key: "sellOrRent",
			width: 150,
			render: (sellOrRent: EListingSellOrRent) => <SellOrRentComponent value={sellOrRent} />,
		},
		{
			title: "PUBLISH",
			dataIndex: "status",
			key: "status",
			width: 200,
			render(status: EListingStatus, record: ListingProperties) {
				return formatUcWords(status);
			},
		},
	].filter(Boolean) as TableProps<ListingProperties>["columns"];

	console.log("listings:", data);
	return (
		<Card
			bordered={false}
			size="small"
		>
			<Filter maxWidth={"100%"}>
				<Col
					xs={{ span: 12 }}
					md={{ span: 12 }}
				>
					<Input
						className="outer-shadow"
						placeholder="Search by Title, Listing ID or Agent Name..."
						suffix={<SearchOutlined />}
						allowClear
						onChange={(e) => setSearch(e.target.value)}
						value={search}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 4 }}
				>
					<Select
						virtual={true}
						allowClear
						onChange={(v) =>
							setQuery((prev: any) => ({
								...prev,
								filterSellOrRent: v,
								offset: 0,
							}))
						}
						className="outer-shadow"
						placeholder="Sell or Rent"
						value={query.filterSellOrRent}
						options={[
							{
								label: "All",
								value: "",
							},
							{
								label: "Sell",
								value: EListingSellOrRent.SELL,
							},
							{
								label: "Rent",
								value: EListingSellOrRent.RENT,
							},
							Select,
						]}
					/>
				</Col>

				<Col
					xs={{ span: 12 }}
					md={{ span: 6 }}
				>
					<FilterOffice
						value={query.filterOfficeId}
						onChange={_handleFilterOffice}
					/>
				</Col>
				<Col
					xs={{ span: 12 }}
					md={{ span: 8 }}
				>
					<DatePicker.RangePicker
						ranges={PRESET_DATE_RANGES}
						placeholder={["Posting Date", "Posting Date"]}
						onChange={(_, dateRange: any) => {
							if (dateRange[0] && dateRange[1]) {
								setQuery((prev: any) => ({
									...prev,
									filterPublishAtStartAt: dateRange[0]
										? moment(dateRange[0]).startOf("day").toISOString()
										: undefined,
									filterPublishAtEndAt: dateRange[1]
										? moment(dateRange[1]).endOf("day").toISOString()
										: undefined,
									offset: 0,
								}));
							} else if (dateRange[0]) {
								setQuery((prev: any) => ({
									...prev,
									filterPublishAtStartAt: dateRange[0]
										? moment(dateRange[0]).startOf("day").toISOString()
										: undefined,
									filterPublishAtEndAt: undefined,
									offset: 0,
								}));
							} else if (dateRange[1]) {
								setQuery((prev: any) => ({
									...prev,
									filterPublishAtStartAt: undefined,
									filterPublishAtEndAt: dateRange[1]
										? moment(dateRange[1]).endOf("day").toISOString()
										: undefined,
									offset: 0,
								}));
							} else {
								setQuery((prev: any) => ({
									...prev,
									filterPublishAtStartAt: undefined,
									filterPublishAtEndAt: undefined,
									offset: 0,
								}));
							}
						}}
					/>
				</Col>
			</Filter>

			<Table
				loading={isLoading}
				columns={COLUMNS}
				dataSource={data}
				rowKey="listingId"
				pagination={false}
				scroll={{ x: "100%" }}
			/>
			<CustomPagination
				current={pagination.page}
				total={pagination.totalData}
				defaultPageSize={pagination.perPage}
				pageSize={pagination.perPage}
				onChange={changePage}
			/>
		</Card>
	);
}
